import { Injectable } from '@angular/core';
import { Settings } from '../../app.settings.model';
import { Observable } from 'rxjs';
import { User } from '../../pages/users/user.model';
import { SocketService } from './socket.service';
import { ChatP } from '../../pages/chat/chat.model';
import { MenuService } from '../../theme/components/menu/menu.service';

@Injectable()
export class AuthService {
    // private socketService = SocketService.getInstance();
    public static chats: ChatP[];
    public static cero: boolean;
    public static asd: number = 3;

constructor() {
    
}

public static set setChats(chats: ChatP[]) {
    AuthService.chats = chats
}

public static get getChats() {
    return AuthService.chats;
}

public static checkPermissions(moduleId: number): boolean {
    let permission = false;

    Object.keys(this.getUser().rolePermissions).forEach(key => {
        if (AuthService.getUser().rolePermissions[key].module_id === moduleId) {
              permission = true;
        }
      });

      return permission;
}

public static canEditModule(moduleId: number): boolean {
    let permission = false;

    Object.keys(this.getUser().rolePermissions).forEach(key => {
        if (AuthService.getUser().rolePermissions[key].module_id === moduleId && AuthService.getUser().rolePermissions[key].edit === 1) {
              permission = true;
        }
      });

      return permission;
}

public static canDeleteModule(moduleId: number): boolean {
    let permission = false;

    Object.keys(this.getUser().rolePermissions).forEach(key => {
        if (AuthService.getUser().rolePermissions[key].module_id === moduleId && AuthService.getUser().rolePermissions[key].delete === 1) {
              permission = true;
        }
      });

      return permission;
}

public static getLastLogin(): string {
    return sessionStorage.getItem('lastLogin');
}

public static getUserId(): number {
    return Number(sessionStorage.getItem('userId'));
}

public static getUser(): User {
    return JSON.parse(sessionStorage.getItem('user'));
}

public static setUser(user: User): void {
    sessionStorage.removeItem('user');
    sessionStorage.setItem('user', JSON.stringify(user));
}

// public static set setChats(chats: ChatP[]) {
//     sessionStorage.removeItem('chats');
//     sessionStorage.setItem('chats', JSON.stringify(chats));

//     console.log(JSON.parse(sessionStorage.getItem('chats')));
// }

// public static get getChats(): ChatP[] {
//     return JSON.parse(sessionStorage.getItem('chats'));
// }

public static getCompanyId(): number {
    return parseInt(sessionStorage.getItem('companyId'));
}

public static get isLoggedIn(): boolean {
    return sessionStorage.getItem('isLoggedIn') ? true : false;
}

public static getRole(): number {
    return parseInt(sessionStorage.getItem('roleId'));
}

public static isSuperAdmin(): boolean {
    return parseInt(sessionStorage.getItem('roleId')) === 1;
}

public static isAdmin(): boolean {
    return parseInt(sessionStorage.getItem('roleId')) === 2;
}

public static isEmployee(): boolean {
    return parseInt(sessionStorage.getItem('roleId')) === 3;
}

public static isStudent(): boolean {
    return [4,17].includes(this.getUser().role.id);
}

public static getThemeSettings(): Settings {
    return JSON.parse(sessionStorage.getItem('themeSettings'));
}

public static loggedOut() {
    console.log('Loggedout');
    sessionStorage.removeItem('isLoggedIn');
    sessionStorage.removeItem('user');
    sessionStorage.removeItem('chats');
    sessionStorage.removeItem('themeSettings');
    sessionStorage.removeItem('lastLogin');
    MenuService.totalRejected = null;
    SocketService.getInstance().disconnect();
}

}
